
































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import moment from 'moment';
import {progress} from '@/script/progress';
import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import YearMonthPicker from '@/components/datepicker/YearMonthPicker.vue';
import {渓仁会入出庫集計型, 渓仁会入出庫集計検索依頼型} from '@/type/custom/keijinkai/receiveandreturns';
import {loginModule} from '@/store/authentication/login';
import 渓仁会入出庫集計検索条件チェッカー from '@/type/custom/keijinkai/渓仁会入出庫集計検索条件チェッカー';
import {部署型} from '@/type/department/department';

@Component({
  components: {
    ButtonPanel,
    IconButton,
    ConfirmDialog,
    AlertDialog,
    NormalButton,
    YearMonthPicker,
  },
})
export default class ReceiveAndReturns extends Vue {
  // data
  在庫場所一覧: 部署型[] = [];
  検索条件: 渓仁会入出庫集計検索依頼型 = {...this.デフォルトの検索条件};
  検索結果: 渓仁会入出庫集計型 | null = null;

  選択行番号: number | null = null;
  アラートメッセージ: string[] | string | null = null;

  // computed
  get 表示件数(): number {
    return 0;
  }

  get 所属部署コード(): string {
    return loginModule.部署コードを取得する;
  }

  get デフォルトの検索条件(): 渓仁会入出庫集計検索依頼型 {
    return {
      在庫場所: this.所属部署コード,
      在庫年月: moment().format('YYYY-MM'),
    };
  }

  @Watch('検索条件.在庫場所')
  在庫場所の変更(): void {
    this.検索条件.在庫年月 = moment().format('YYYY-MM');
  }

  // method
  openDialog(name: string): void {
    this.$modal.show(name);
  }

  closeDialog(name: string): void {
    this.$modal.hide(name);
  }

  async クリアする(): Promise<void> {
    this.検索条件 = {...this.デフォルトの検索条件};
    this.検索結果 = null;
    this.選択行番号 = null;
    this.アラートメッセージ = null;
    this.closeDialog('クリアダイアログ');
  }

  検索条件入力エラー判定(項目名: string): boolean {
    const checker = new 渓仁会入出庫集計検索条件チェッカー(this.検索条件);
    return checker.hasError(項目名);
  }

  行が選択されている(行番号: number): boolean {
    if (this.選択行番号 === null) {
      return false;
    }
    return this.選択行番号 === 行番号;
  }

  行を選択する(行番号: number): void {
    this.選択行番号 = 行番号;
  }

  async 検索する(): Promise<void> {
    const checker = new 渓仁会入出庫集計検索条件チェッカー(this.検索条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    await progress(this.渓仁会入出庫集計を検索する);
  }

  async 渓仁会入出庫集計を検索する(): Promise<void> {
    await api.渓仁会入出庫集計を検索する(this.検索条件)
      .then((response: 渓仁会入出庫集計型) => {
        this.検索結果 = response;
      }).catch((error: any) => {
        if (error.data.errors) {
          this.showAlert(error.data.errors);
        }
        if (error.data.message && !error.data.errors) {
          this.showAlert(error.data.message);
        }
      });
  }

  async Excelファイル出力前入力チェックをする(): Promise<void> {
    const checker = new 渓仁会入出庫集計検索条件チェッカー(this.検索条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    this.openDialog('出力ダイアログ');
  }

  async 出力する(): Promise<void> {
    await progress(this.渓仁会入出庫集計を出力する);
    this.closeDialog('出力ダイアログ');
  }

  async 渓仁会入出庫集計を出力する(): Promise<void> {
    if (!this.検索条件) {
      return;
    }
    await download.渓仁会入出庫集計をExcel出力する('渓仁会入出庫集計表.xlsx', this.検索条件);
  }

  async PDFファイル出力前入力チェックをする(): Promise<void> {
    const checker = new 渓仁会入出庫集計検索条件チェッカー(this.検索条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    this.openDialog('印刷ダイアログ');
  }

  async 印刷する(): Promise<void> {
    await progress(this.渓仁会入出庫集計表をPDF出力する);
    this.closeDialog('印刷ダイアログ');
  }

  async 渓仁会入出庫集計表をPDF出力する(): Promise<void> {
    if (!this.検索条件) {
      return;
    }
    await download.渓仁会入出庫集計表をPDF出力する('渓仁会入出庫集計表.pdf', this.検索条件);
  }

  async 在庫場所を取得する() {
    this.在庫場所一覧 = await api.部署一覧を取得する();
  }

  showAlert(message: string[] | string | null): void {
    this.アラートメッセージ = message;
    this.$modal.show('入出庫集計表アラート');
  }

  // lifecycle hook
  created(): void {
    this.在庫場所を取得する();
  }
}
